var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSurveyDeveloper(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 95,
    height: 106,
    viewBox: "0 0 95 106",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.5 0h94v106H.5V0z",
    fill: "#5959EB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 7h80v92h-80V7z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.512 16.893a1.5 1.5 0 0 1 .095 2.12l-7.322 8.007-4.69-3.546a1.5 1.5 0 1 1 1.81-2.393l2.51 1.899 5.478-5.992a1.5 1.5 0 0 1 2.12-.095zM27.512 35.893a1.5 1.5 0 0 1 .095 2.12l-7.322 8.008-4.69-3.547a1.5 1.5 0 1 1 1.81-2.393l2.51 1.898 5.478-5.991a1.5 1.5 0 0 1 2.12-.095z",
    fill: "#19D89F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.44 54.94a1.5 1.5 0 0 0 0 2.12l7 7a1.5 1.5 0 0 0 2.12-2.12l-7-7a1.5 1.5 0 0 0-2.12 0z",
    fill: "#BF3DC2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.56 54.94a1.5 1.5 0 0 1 0 2.12l-7 7a1.5 1.5 0 0 1-2.12-2.12l7-7a1.5 1.5 0 0 1 2.12 0z",
    fill: "#BF3DC2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35 21a4.5 4.5 0 0 1 4.5-4.5h37a4.5 4.5 0 1 1 0 9h-37A4.5 4.5 0 0 1 35 21zM35 40a4.5 4.5 0 0 1 4.5-4.5h37a4.5 4.5 0 1 1 0 9h-37A4.5 4.5 0 0 1 35 40zM35 59a4.5 4.5 0 0 1 4.5-4.5h37a4.5 4.5 0 1 1 0 9h-37A4.5 4.5 0 0 1 35 59z",
    fill: "#000"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 92h80v7h-80v-7z",
    fill: "#F8D856"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M62.5 72 59 86M55.5 75.5l-8 3.5 8 3.5M67 75.5l8 3.5-8 3.5",
    stroke: "#5959EB",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSurveyDeveloper);
export default __webpack_public_path__ + "static/media/survey-developer.372cddb856aa5d2d6893167fd9607c6e.svg";
export { ForwardRef as ReactComponent };